import moment from "moment";
import { leaderboardConstants } from "../../../../NRP/constants/leaderboardConstants";
import authHeader from "../../../../services/auth/auth-header";
import { postApi, getApi } from "../../../../services/helpers/nrpApiCalls";
import { toast } from "react-toastify";
import { LocalStorageService } from "../../../../services";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { competenciesAssessments } from "../../../../NRP/pages/dashboard/data";
let getLeaderboardCampaignData =
  (
    campaign,
    startDate,
    endDate,
    pageNumber,
    pageSize,
    status,
    searchValue,
    customFilters,
    sortModel
  ) =>
  (dispatch) => {
    dispatch(request());
    let makeBody;
    let page;
    let sorting = sortModel && sortModel[0];

    if (searchValue.length > 0) {
      let val = searchValue.trim();
      page = pageNumber + 1;
      makeBody = {
        filters: {
          sortField: sorting.field,
          sortOrder: sorting.sort === "desc" ? "descend" : sorting.sort,
          filtersParams: [
            {
              conditionOp: "or",
              columnName: "name",
              type: "_like",
              value: val,
            },
            {
              conditionOp: "or",
              columnName: "email",
              type: "_like",
              value: val,
            },
          ],
        },
      };
    } else if (customFilters.length > 0) {
      page = pageNumber + 1;
      makeBody = {
        filters: {
          sortField: sorting.field,
          sortOrder: sorting.sort === "desc" ? "descend" : sorting.sort,
          filtersParams: customFilters,
        },
      };
    } else {
      page = pageNumber + 1;
      makeBody = {
        filters: {
          sortField: sorting.field,
          sortOrder: sorting.sort === "desc" ? "descend" : sorting.sort,
        },
      };
    }

    let { campaignId } = campaign;

    let start = moment(startDate).format("YYYY-MM-DD");
    let end = moment(new Date()).add(2, "days").format("YYYY-MM-DD");

    let apiCallRequest = {
      url: `/leaderboard/campaigns/${campaignId}/scores/raw/${page}?perpage=${pageSize}&status=${status}&search=&startDate=${start}&endDate=${end}`,
      data: makeBody,
      config: {
        headers: authHeader(),
      },
    };
    postApi(apiCallRequest)
      .then((res) => {
        let response = res.data;
        let headerColumnNames = response.listOfCompetenciesType;
        let leaderBoardData = response.leaderBoard;
        leaderBoardData.forEach((obj) => {
          const dateMoment = moment(obj.dob, [
            "ddd MMM DD YYYY HH:mm:ss ZZ",
            "YYYY-MM-DD",
            "MM/DD/YYYY",
            "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (Pakistan Standard Time)",
          ]);
          let cdh = dateMoment.isValid()
            ? dateMoment.format("YYYY-MM-DD")
            : obj.dob;
          const dobYear = dateMoment.isValid()
            ? dateMoment.format("YYYY")
            : null;
          const dobMonth = dateMoment.isValid()
            ? dateMoment.format("MM")
            : null;
          const dobDay = dateMoment.isValid() ? dateMoment.format("DD") : null;

          // Parse the graduationDate string into a Date object
          const date = new Date(obj.graduationDate);
          // Extract the month and year from the Date object
          const month = date.toLocaleString("default", { month: "short" });
          const year = date.getFullYear();
          // Update the graduationDate property with the formatted string
          obj.graduationDate = `${month}-${year}`;
          obj.dob =
            dobYear && dobMonth && dobDay
              ? `${dobYear}-${dobMonth}-${dobDay}`
              : obj.dob;
        });
        let totalUsers = response.totalUsersCount;
        let totalAssessmentsArray = response.competecyType;
        let totalAssessments = [];
        totalAssessmentsArray &&
          totalAssessmentsArray.forEach((competency) => {
            totalAssessments.push({
              headerName: competenciesAssessments[
                competency.title.replace("''", "'")
              ]
                ? competenciesAssessments[competency.title.replace("''", "'")]
                    .title
                : competency.title,
              field: competency.title,
              sort: "desc",
              width: 120,
              headerAlign: "center",
              align: "center",
            });
          });
        let mainHeaders = [];
        let defaultAllColumn = headerColumnNames;
        for (let i = 0; i < headerColumnNames.length; i++) {
          const element = headerColumnNames[i];
          let mdata = {
            headerName:
              element.title.charAt(0).toUpperCase() +
              element.title
                .slice(1)
                .replace(/([A-Z])/g, " $1")
                .trim(),
            field: element.title,
            sort: "desc",
            headerAlign:
              element.fieldType === ("number" || "dob") ? "center" : "left",
            align:
              element.fieldType === ("number" || "dob") ? "center" : "left",
            width:
              element.title === "name" ||
              element.title === "qualification" ||
              element.title === "university"
                ? "200"
                : "100",
          };
          if (mdata.field === "name" || mdata.field === "city") {
            LocalStorageService.setObject("personalFeilds", ["name", "city"]);
            mainHeaders.push(mdata);
          }

          if (mdata.field === "totalConativeScore") {
            mdata.headerName = "Total Cognitive Score";
          }

          if (
            mdata.field === "qualification" ||
            mdata.field === "university" ||
            mdata.field === "percentileRank" ||
            mdata.field === "totalScore" ||
            mdata.field === "totalCompetencyScore" ||
            mdata.field === "totalConativeScore"
          ) {
            LocalStorageService.setObject("totalScoresFeilds", [
              "totalCompetencyScore",
              "totalConativeScore",
              "totalScore",
              "percentileRank",
            ]);

            LocalStorageService.setObject("educationFeilds", [
              "university",
              "qualification",
            ]);
            mainHeaders.push(mdata);
          }
        }

        let campaginData = {
          headerColumnNames: mainHeaders,
          leaderBoardData,
          totalUsers,
        };
        dispatch(success(campaginData, defaultAllColumn, totalAssessments));
      })
      .catch((err) => {
        dispatch(failure(err.message));
      });

    function request() {
      return {
        type: leaderboardConstants.LEADERBOARD_CAMPAGIN_DATA_REQUEST,
        payload: {
          isLoading: true,
        },
      };
    }

    function success(campaginData, defaultAllColumn, totalAssessments) {
      return {
        type: leaderboardConstants.LEADERBOARD_CAMPAGIN_DATA_SUCCESS,
        payload: {
          campaginData,
          isLoading: false,
          defaultAllColumn,
          totalAssessments,
        },
      };
    }
    function failure(error) {
      return {
        type: leaderboardConstants.LEADERBOARD_CAMPAGIN_DATA_FAILURE,
        payload: {
          error,
          isLoading: false,
        },
      };
    }
  };

// Toolbar Api Call

let sendSingleInvite = (campaginData, emailObj) => (dispatch) => {
  let { campaignId } = campaginData;
  let { to } = emailObj;

  const id = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
  let apiCallRequest = {
    url: `/mail/sendinvite/${campaignId}`,
    data: {
      email: to,
    },
    config: {
      headers: authHeader(),
    },
  };

  postApi(apiCallRequest)
    .then((res) => {
      toast.update(id, {
        render: "Invite Sent",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch((err) => {
      toast.update(id, {
        render: "Email not found!",
        type: "error",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });
};

let downloadResume = (selectedUsers) => (dispatch) => {
  const id = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });

  let apiCallRequest = {
    url: `/users/downloadzip`,
    data: {
      ids: selectedUsers,
    },
    config: {
      headers: authHeader(),
      responseType: "blob",
    },
  };

  postApi(apiCallRequest)
    .then((res) => {
      toast.update(id, {
        render: "Download Success",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      let allData = res.data;
      let blob = new Blob([allData], { type: "application/zip" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Resumes.zip";
      link.click();
    })
    .catch((err) => {
      toast.update(id, {
        render: "No resume found!",
        type: "error",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });
};

// Single User Profile

let singleUserResume = (resume) => (dispatch) => {
  resume = resume.substring(54, resume.length);
  const id = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });

  let apiCallRequest = {
    url: `/users/downloadb/${resume}`,
    data: {},
    config: {
      headers: authHeader(),
      responseType: "blob",
    },
  };
  getApi(apiCallRequest)
    .then((response) => {
      toast.update(id, {
        render: "Download Success",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      let blob = new Blob([response.data], { type: "application/pdf" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Report.pdf";
      link.click();
    })
    .catch((err) => {
      toast.update(id, {
        render: "Download Failed",
        type: "error",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });
};

// Set Custom Headers for leaderboard

let getCustomHeaders = (headers) => (dispatch) => {
  if (headers.length > 0) {
    dispatch(success(headers));
  } else {
    dispatch(failure(null));
  }
  function success(headers) {
    return {
      type: leaderboardConstants.CUSTOM_HEADERS_NAMES_SUCCESS,
      payload: {
        headers,
      },
    };
  }
  function failure(error) {
    return {
      type: leaderboardConstants.CUSTOM_HEADERS_NAMES_ERROR,
      payload: {
        headers,
      },
    };
  }
};

// Get existing Tags

let getAllTags = (campaign) => (dispatch) => {
  let { campaignId } = campaign;
  let apiCallRequest = {
    url: `/tags/${campaignId}`,
    data: {},
    config: {
      headers: authHeader(),
    },
  };

  getApi(apiCallRequest)
    .then((res) => {
      let data = res.data.tags;
      let newArray = [];
      let topCanidates = {};
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        element.label = data[i].name;
        element.value = data[i].name;
        if (element.name === "Top Candidates") {
          topCanidates = element;
        } else {
          newArray.push(element);
        }
      }
      if (Object.keys(topCanidates).length > 0) {
        newArray.unshift(topCanidates);
      }
      dispatch(success(newArray));
    })
    .catch((err) => {
      dispatch(failure(err.message));
    });

  function success(data) {
    return {
      type: leaderboardConstants.CAMPAIGN_TAGS_SUCCESS,
      payload: {
        tagsList: data,
      },
    };
  }
  function failure(error) {
    return {
      type: leaderboardConstants.CAMPAIGN_TAGS_ERROR,
      payload: {
        error,
      },
    };
  }
};

// Add New Tag
let addCustomTag = (tag, campaign) => (dispatch) => {
  let { campaignId } = campaign;

  const loadId = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
  let apiCallRequest = {
    url: `/tags`,
    data: {
      tags: [tag],
      campaignId,
    },
    config: {
      headers: authHeader(),
    },
  };

  postApi(apiCallRequest)
    .then((res) => {
      toast.update(loadId, {
        render: "List Added",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch((error) => {
      toast.update(loadId, {
        render: "List adding failed",
        type: "error",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });
};

// get users with tags

let addUsersToTag = (usersId, campaign, id) => (dispatch) => {
  const loadId = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
  let { campaignId } = campaign;
  let apiCallRequest = {
    url: `/userTags`,
    data: {
      userIds: usersId,
      campaignId,
      tagIds: [id],
    },
    config: {
      headers: authHeader(),
    },
  };

  postApi(apiCallRequest)
    .then((response) => {
      toast.update(loadId, {
        render: "Users Added",
        type: "success",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    })
    .catch((err) => {
      toast.update(loadId, {
        render: "Adding users failed",
        type: "error",
        isLoading: false,
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    });
};

// Export Excel Data
let exportAllData = (campaign, total, status) => async (dispatch) => {
  let page = 1;
  let count = Math.ceil(total / 1000);
  let allUsersExcelData = [];
  let { campaignId } = campaign;
  let start = moment("2010-01-10").format("YYYY-MM-DD");
  // let end = moment(new Date()).format("YYYY-MM-DD");
  let end = moment(new Date()).add(2, "days").format("YYYY-MM-DD");
  let loadId = toast.loading("Please wait...", {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
  async function loop(page) {
    // This would be the POST request
    let apiCallRequest = {
      url: `/leaderboard/campaigns/${campaignId}/scores/raw/${page}?perpage=1000&status=${status ? status : 0}&search=&startDate=${start}&endDate=${end}`,
      data: {
        filters: {
          sortField: null,
          sortOrder: null,
        },
      },
      config: {
        headers: authHeader(),
      },
    };

    let promise = new Promise((resolve, reject) => {
      postApi(apiCallRequest)
        .then((response) => {
          // allUsersExcelData = allUsersExcelData.concat(
          //   response.data.leaderBoard
          // );

          // 27_Mar
          allUsersExcelData = allUsersExcelData.concat(
            response.data.leaderBoard.map(user => ({
              ...user,
                totalScore: isNaN(user.totalScore) ? 0 : user.totalScore,
                gamePlayPercentage: isNaN(user.gamePlayPercentage) ? 0 : user.gamePlayPercentage,
                // Include other properties as needed
            }))
        );

          toast.update(loadId, {
            render: `fetched ${allUsersExcelData.length} out of ${total}`,
            type: "default",
            isLoading: false,
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });

          if (response.status) {
            resolve("done!");
          }
        })
        .catch((error) => {
          resolve("failed!");
          toast.update(loadId, {
            render: "Failed to export data",
            type: "error",
            isLoading: false,
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        });
    });

    await promise;

    if (page < count) {
      await loop(page + 1);
    }
  }

  await loop(page);

  const newArray = allUsersExcelData.map(
    ({ areaOfInterest1_2, areaOfInterest2_2, dob, ...rest }) => {
      const dateMoment = moment(dob, [
        "ddd MMM DD YYYY HH:mm:ss ZZ",
        "YYYY-MM-DD",
        "MM/DD/YYYY",
        "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (Pakistan Standard Time)",
      ]);
      let cdh = dateMoment.isValid() ? dateMoment.format("YYYY-MM-DD") : dob;
      const dobYear = dateMoment.isValid() ? dateMoment.format("YYYY") : null;
      const dobMonth = dateMoment.isValid() ? dateMoment.format("MM") : null;
      const dobDay = dateMoment.isValid() ? dateMoment.format("DD") : null;



      return {
        ...rest,
        areaOfInterest1_2,
        areaOfInterest2_2,
        dob:
          dobYear && dobMonth && dobDay
            ? `${dobYear}-${dobMonth}-${dobDay}`
            : dob,
      };
    }
  );

  for (let assessment of newArray) {
    for (let [title, value] of Object.entries(assessment)) {
      if (competenciesAssessments.hasOwnProperty(title)) {
        assessment[competenciesAssessments[title].title] = value;
        delete assessment[title];
      }
    }
  }

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(newArray);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, "All Userss" + fileExtension);

  toast.update(loadId, {
    render: `Fetched data successfully`,
    type: "success",
    isLoading: false,
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
  });
};

export {
  getLeaderboardCampaignData,
  downloadResume,
  sendSingleInvite,
  singleUserResume,
  getCustomHeaders,
  getAllTags,
  addCustomTag,
  addUsersToTag,
  exportAllData,
};
